<template>
  <div class="user-wrap">
    <main class="mine">
      <section class="profile-header">
        <div class="profile-info">
          <img
            class="profile-avatar"
            src="../images/home/headDefault.png"
            alt=""
          >
          <div class="profile-copy">
            <div class="profile-name-row">
              <p class="profile-name">
                {{ displayName }}
              </p>
              <span
                v-if="userVipName"
                class="vip-badge"
              >{{ userVipName }}</span>
            </div>
            <!-- <p class="profile-id">
              {{ $t('user.memberId') }}: {{ data.uid || '--' }}
            </p> -->
            <p class="profile-detail">
              {{ $t('d.creditscore') }}: {{ data.credit || 0 }}
            </p>
            <div class="promo-code-row">
              <span class="profile-detail">
                {{ $t('d.code') }}: {{ data.yaocode || '--' }}
              </span>
              <button
                v-if="data.yaocode"
                v-clipboard="() => data.yaocode"
                v-clipboard:success="copyPromoCode"
                class="copy-code"
                type="button"
              >
                {{ $t('invest_bank.copy') }}
              </button>
            </div>
          </div>
        </div>
        <div
          class="notice-button"
          @click="goToNotice"
        >
          <van-icon
            name="smile-comment"
            size="22"
            color="#262626"
            :badge="unreadCount || undefined"
          />
        </div>
      </section>

      <section class="balance-card">
        <div class="balance-content">
          <div class="balance-title">
            <i />
            <span>{{ $t('investdetail.accba') }}</span>
          </div>
          <div class="balance-amount">
            <span class="balance-unit">{{ utils_moneyMark() }}</span>
            <span class="balance-number">{{ formatAmount(data.money) }}</span>
          </div>
          <div class="balance-stats">
            <div class="balance-stat">
              <span class="stat-label">{{ $t('d.frozen') }}</span>
              <span class="stat-value">{{ formatAmount(data.frozenmoney) }}</span>
            </div>
            <div class="balance-stat">
              <span class="stat-label">{{ $t('d.todayrewards') }}</span>
              <span class="stat-value">{{ formatAmount(data.reward) }}</span>
            </div>
          </div>
        </div>
        <button
          class="invite-row"
          type="button"
          @click="$router.push('/activity')"
        >
          <span class="invite-label">
            <span class="invite-icon">
              <van-icon name="gift-o" />
            </span>
            {{ $t('activityTasks.title') }}
          </span>
          <van-icon
            class="invite-arrow"
            name="arrow"
          />
        </button>
      </section>

      <section class="quick-actions">
        <button
          class="quick-action quick-action-primary"
          type="button"
          @click="$router.push('/invest')"
        >
          <img
            src="../images/ban1/btc.png"
            alt=""
          >
          <span>{{ $t('shopds.topup') }}</span>
        </button>
        <button
          class="quick-action quick-action-secondary"
          type="button"
          @click="$router.push('/pay')"
        >
          <img
            src="../images/ban1/cash.png"
            alt=""
          >
          <span>{{ $t('index.withdraw') }}</span>
        </button>
      </section>

      <img
        class="promotion-banner"
        src="../images/ban1/foryou.png"
        alt=""
      >

      <section class="settings-list">
        <van-cell
          v-for="item in menuItems"
          :key="item.route"
          :icon="item.icon"
          :title="$t(item.label)"
          is-link
          @click="$router.push(item.route)"
        />
      </section>

      <button
        class="logout-button"
        type="button"
        @click="logout"
      >
        {{ $t('safe.signOut') }}
      </button>
    </main>

    <van-popup
      v-model="show"
      round
      :style="popupStyle"
    >
      {{ msg }}
    </van-popup>

    <div
      v-if="msgShow"
      ref="kefu"
      class="kefu"
      :class="showKefu ? '' : 'kefu_hide'"
      @click="kefuTo"
    >
      <img
        class="kefu_img"
        src="../images/shop2/kefu.jpg"
        alt=""
      >
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import Clipboard from 'v-clipboard';
import {
  Cell,
  Icon,
  Popup,
  Toast,
} from 'vant';

Vue.use(Cell).use(Clipboard).use(Icon).use(Popup).use(Toast);

export default {
  name: 'User',
  data() {
    return {
      data: {},
      msg: '',
      msgShow: true,
      show: false,
      showKefu: false,
      syncTimer: null,
      menuItems: [
        // { route: '/grap', icon: 'cart', label: 'shopd.grab' },
        { route: '/moneybag', icon: 'paid', label: 'user.myWallet' },
		
        { route: '/cashlist', icon: 'certificate', label: 'user.withdrawalRecord' },
        { route: '/teamhis', icon: 'friends-o', label: 'shopds.invite' },
		{ route: '/about', icon: 'question', label: 'shopds.help' },
        // { route: '/addr', icon: 'manager', label: 'shopd.readdr' },
        // { route: '/notice', icon: 'smile-comment', label: 'notice.message' },
        { route: '/setpwd', icon: 'lock', label: 'safe.signInPassword' },
        { route: '/setpaypwd', icon: 'shield-o', label: 'safe.paymentPassword' },
        { route: '/language', icon: 'other-pay', label: 'safe.language' },
      ],
      popupStyle: {
        'font-weight': 'bold',
        'line-height': '30px',
        padding: '15px',
        width: '60%',
      },
    };
  },
  computed: {
    displayName() {
      return this.data.name || this.data.mobile || '--';
    },
    unreadCount() {
      return Number(this.data.un_read_num) || 0;
    },
    userVipName() {
      return this.data.vip_name || (this.data.vip ? `VIP${this.data.vip}` : '');
    },
  },
  created() {
    this.$parent.footer('user');
  },
  mounted() {
    this.start();
    document.body.addEventListener('scroll', this.hideKefuOnScroll, false);
    document.addEventListener('click', this.hideKefuOnOutsideClick, false);
  },
  beforeDestroy() {
    document.body.removeEventListener('scroll', this.hideKefuOnScroll, false);
    document.removeEventListener('click', this.hideKefuOnOutsideClick, false);
    if (this.syncTimer) {
      clearTimeout(this.syncTimer);
    }
  },
  methods: {
    formatAmount(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount.toFixed(2) : '0.00';
    },
    goToNotice() {
      this.$router.push('/notice');
    },
    copyPromoCode() {
      Toast.success({
        message: this.$t('invest_qrcode.copySucceeded'),
        width: '60%',
      });
    },
    hideKefuOnScroll() {
      this.showKefu = false;
    },
    hideKefuOnOutsideClick(event) {
      if (this.showKefu && this.$refs.kefu && !this.$refs.kefu.contains(event.target)) {
        this.showKefu = false;
      }
    },
    kefuTo() {
      if (this.showKefu) {
        this.$router.push('/kefu');
        return;
      }
      this.showKefu = true;
    },
    sync() {
      Fetch('/index/sync', {}, null, false).then((response) => {
        const notices = response.data;
        if (notices && notices.length > 0) {
          this.msg = notices[0].content;
          this.show = true;
          setTimeout(() => {
            Fetch('/user/notice_view', { id: notices[0].id });
          }, 2000);
        }
      });
    },
    start() {
      Fetch('/user/info').then((response) => {
        this.data = response.data || {};
      });
      this.syncTimer = setTimeout(() => {
        this.sync();
      }, 2000);
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace('/');
    },
  },
};
</script>

<style lang="less" scoped>
.user-wrap {
  min-height: 100vh;
}

.mine {
  position: relative;
  min-height: calc(100vh - 1.5rem);
  overflow: hidden;
  padding: .64rem .42667rem 2rem;
  box-sizing: border-box;
}

.mine::before {
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  left: 0;
  height: 4.8rem;
  background: url('../images/ban1/ppbg.png') no-repeat center top / 100% auto;
  content: '';
  pointer-events: none;
}

.mine > * {
  position: relative;
  z-index: 1;
}

.profile-header,
.profile-info,
.notice-button,
.balance-title,
.balance-amount,
.quick-actions,
.quick-action,
.invite-row,
.invite-label {
  display: flex;
  align-items: center;
}

.profile-header {
  justify-content: space-between;
  min-height: 1.6rem;
}

.profile-info {
  min-width: 0;
}

.profile-crown {
  flex: 0 0 auto;
  width: 1.6rem;
  height: 1.6rem;
  margin-right: .16rem;
  object-fit: contain;
}

.profile-text {
  min-width: 0;
}

.profile-name,
.profile-id,
.balance-title,
.balance-amount,
.balance-stat,
.settings-list,
.logout-button {
  margin: 0;
}

.profile-name {
  overflow: hidden;
  color: #171717;
  font-size: .42667rem;
  font-weight: 700;
  line-height: .56rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.profile-id {
  margin-top: .08rem;
  overflow: hidden;
  color: #292929;
  font-size: .32rem;
  line-height: .42667rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-button {
  flex: 0 0 auto;
  justify-content: center;
  width: .8rem;
  height: .8rem;
  cursor: pointer;
}

.balance-card {
  margin-top: .56rem;
  overflow: hidden;
  border: .02667rem solid #202020;
  border-radius: .13333rem;
  background: radial-gradient(circle at 45% 0%, #ff4d72 0%, #e31c5f 42%, #bd1e59 100%);
}

.balance-content {
  padding: .32rem .32rem .28rem;
}

.balance-title {
  color: #f6dbe3;
  font-size: .32rem;
  font-weight: 500;
  line-height: .42667rem;
}

.balance-title img {
  width: .53333rem;
  height: .53333rem;
  margin-right: .13333rem;
  object-fit: contain;
}

.balance-amount {
  margin-top: .2rem;
  line-height: .8rem;
}

.balance-number {
  color: #fff;
  font-size: .64rem;
  font-weight: 700;
}

.balance-unit {
  margin-right: .10667rem;
  color: #36c8b5;
  font-size: .42667rem;
  font-weight: 500;
}

.balance-stats {
  display: flex;
  margin-top: .28rem;
  padding-top: .24rem;
  border-top: .02667rem solid rgba(255, 255, 255, .25);
}

.balance-stat {
  flex: 1;
  min-width: 0;
}

.balance-stat + .balance-stat {
  padding-left: .32rem;
  border-left: .02667rem solid rgba(255, 255, 255, .25);
}

.stat-label,
.stat-value {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stat-label {
  color: rgba(255, 255, 255, .75);
  font-size: .26667rem;
  line-height: .37333rem;
}

.stat-value {
  margin-top: .05333rem;
  color: #fff;
  font-size: .37333rem;
  font-weight: 700;
  line-height: .48rem;
}

.invite-row {
  justify-content: space-between;
  width: 100%;
  min-height: 1.06667rem;
  padding: 0 .53333rem;
  border: 0;
  border-top: .02667rem solid rgba(0, 0, 0, .08);
  background: #f5f5f5;
  color: #1e1e1e;
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.invite-label {
  min-width: 0;
  font-size: .37333rem;
  font-weight: 500;
}

.invite-label img {
  flex: 0 0 auto;
  width: .69333rem;
  height: .69333rem;
  margin-right: .10667rem;
  object-fit: contain;
}

.quick-actions {
  gap: .32rem;
  justify-content: space-between;
  margin-top: .32rem;
}

.quick-action {
  flex: 1;
  justify-content: center;
  min-width: 0;
  height: 1.06667rem;
  border: .02667rem solid #202020;
  border-radius: .13333rem;
  background: #fff;
  color: #202020;
  cursor: pointer;
  font: inherit;
  font-size: .32rem;
  font-weight: 500;
}

.quick-action img {
  flex: 0 0 auto;
  width: .64rem;
  height: .64rem;
  margin-right: .16rem;
  object-fit: contain;
}

.quick-action span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.promotion-banner {
  height: 2.56rem;
  margin-top: .32rem;
  border-radius: .13333rem;
  background: url('../images/ban1/foryou.png') no-repeat center / 100% 100%;
}

.settings-list {
  margin-top: .32rem;
  padding: .08rem .53333rem;
  border-radius: .26667rem;
  background: #fff;
}

/deep/ .settings-list .van-cell {
  padding: .36rem 0;
  background: transparent;
  color: #202020;
  font-size: .37333rem;
  line-height: .56rem;
}

/deep/ .settings-list .van-cell:not(:last-child)::after {
  right: 0;
  left: .8rem;
  border-color: #f0f0f0;
}

/deep/ .settings-list .van-cell__left-icon {
  min-width: .69333rem;
  margin-right: .16rem;
  color: #292929;
  font-size: .53333rem;
  line-height: .56rem;
}

/deep/ .settings-list .van-cell__right-icon {
  color: #999;
  font-size: .42667rem;
}

.logout-button {
  display: block;
  width: 100%;
  height: 1.04rem;
  margin-top: .32rem;
  border: 0;
  border-radius: .13333rem;
  background: linear-gradient(90deg, #ff385c, #bd1e59);
  box-shadow: 0 .16rem .26667rem rgba(149, 37, 75, .24);
  color: #fff;
  cursor: pointer;
  font: inherit;
  font-size: .38667rem;
  font-weight: 500;
}

.kefu {
  position: fixed;
  z-index: 10;
  right: .08rem;
  bottom: 1.72rem;
  width: 1.2rem;
  overflow: hidden;
  border-radius: .6rem 0 0 .6rem;
  box-shadow: 0 .05333rem .16rem rgba(0, 0, 0, .16);
  cursor: pointer;
  transition: transform .2s ease;
}

.kefu-hide {
  transform: translateX(.88rem);
}

.kefu-img {
  display: block;
  width: 100%;
}


.mine {
  min-height: calc(100vh - 1.5rem);
  padding: .48rem .4rem 2.36rem;

}

.mine::before {
  display: none;
}

.profile-header {
  min-height: 1.44rem;
  margin: 0 .02667rem;
}

.profile-info {
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.profile-avatar {
  flex: 0 0 auto;
  width: 60px;
  height: 60px;
  margin-right: .24rem;
  border: .05333rem solid #fff;
  border-radius: 50%;
  box-shadow: 0 .10667rem .24rem rgba(34, 34, 34, .14);
  object-fit: cover;
}

.profile-copy {
  min-width: 0;
  padding-top: .01333rem;
}

.profile-name-row,
.promo-code-row {
  display: flex;
  align-items: center;
  min-width: 0;
}

.profile-name {
  max-width: 3.1rem;
  color: #222;
  font-size: .4rem;
  line-height: .50667rem;
}

.vip-badge {
  flex: 0 0 auto;
  margin-left: .13333rem;
  padding: .04rem .13333rem;
  border-radius: .21333rem;
  background: #ff385c;
  color: #fff;
  font-size: .21333rem;
  font-weight: 700;
  line-height: .29333rem;
}

.profile-id,
.profile-detail {
  color: #717171;
  font-size: .24rem;
  line-height: .33333rem;
}

.profile-id {
  margin-top: .04rem;
}

.profile-detail {
  margin: .02667rem 0 0;
}

.promo-code-row {
  gap: .10667rem;
}

.promo-code-row .profile-detail {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-code {
  flex: 0 0 auto;
  min-height: .4rem;
  padding: 0 .16rem;
  border: 0;
  border-radius: .10667rem;
  background: #222;
  color: #fff;
  cursor: pointer;
  font: inherit;
  font-size: .2rem;
  font-weight: 600;
}

.notice-button {
  width: .72rem;
  height: .72rem;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 .08rem .2rem rgba(34, 34, 34, .12);
}

.balance-card {
  margin-top: .44rem;
  border: .02667rem solid #ebebeb;
  border-radius: .26667rem;
  background: linear-gradient(135deg, #fff 0%, #fffafb 100%);
  box-shadow: 0 .13333rem .32rem rgba(0, 0, 0, .06);
}

.balance-content {
  padding: .4rem .4rem .32rem;
}

.balance-title {
  color: #717171;
  font-size: .26667rem;
  font-weight: 600;
  line-height: .34667rem;
}

.balance-title i {
  display: block;
  width: .10667rem;
  height: .29333rem;
  margin-right: .13333rem;
  border-radius: .08rem;
  background: #ff385c;
}

.balance-amount {
  margin-top: .12rem;
  line-height: .74667rem;
}

.balance-number {
  color: #222;
  font-size: .66667rem;
  letter-spacing: -.02rem;
}

.balance-unit {
  color: #717171;
  font-size: .29333rem;
}

.balance-stats {
  margin-top: .24rem;
  padding-top: .22rem;
  border-top-color: #ebebeb;
}

.balance-stat + .balance-stat {
  padding-left: .32rem;
  border-left-color: #ebebeb;
}

.stat-label {
  color: #717171;
  font-size: .22667rem;
}

.stat-value {
  color: #222;
  font-size: .33333rem;
}

.invite-row {
  min-height: .96rem;
  padding: 0 .4rem;
  border-top-color: #ebebeb;
  border-radius: 0 0 .24rem .24rem;
  background: rgba(255, 255, 255, .84);
  color: #3b3b3b;
}

.invite-label {
  font-size: .32rem;
}

.invite-label img {
  width: .58667rem;
  height: .58667rem;
  margin-right: .13333rem;
}

.quick-actions {
  gap: .2rem;
  margin-top: .3rem;
}

.quick-action {
  height: .96rem;
  border-color: #ddd;
  border-radius: .2rem;
  color: #3b3b3b;
  font-size: .29333rem;
}

.quick-action img {
  width: .56rem;
  height: .56rem;
  margin-right: .13333rem;
}

.quick-action-primary {
  border-color: #ff385c;
  background: #ff385c;
  box-shadow: 0 .13333rem .21333rem rgba(255, 56, 92, .22);
  color: #fff;
}

.quick-action-secondary img {
  filter: grayscale(1) brightness(.35);
}

.promotion-banner {
  display: block;
  width: 100%;
  height: auto;
  margin-top: .4rem;
  border-radius: .24rem;
  background: none;
  box-shadow: 0 .10667rem .32rem rgba(0, 0, 0, .08);
}

.settings-list {
  margin-top: .4rem;
  padding: .08rem .32rem;
  border: .02667rem solid #ededed;
  border-radius: .26667rem;
  box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .035);
}

/deep/ .settings-list .van-cell {
  padding: .34rem .08rem;
  color: #3b3b3b;
  font-size: .32rem;
}

/deep/ .settings-list .van-cell:not(:last-child)::after {
  left: .88rem;
  border-color: #f1f1f1;
}

/deep/ .settings-list .van-cell__left-icon {
  min-width: .64rem;
  color: #484848;
  font-size: .48rem;
}

.logout-button {
  height: .96rem;
  margin-top: .32rem;
  border: .02667rem solid #ddd;
  border-radius: .2rem;
  background: #fff;
  box-shadow: none;
  color: #484848;
  font-size: .32rem;
}

.kefu {
  right: .16rem;
  bottom: 1.68rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: .8rem;
  height: .8rem;
  border: .02667rem solid #eee;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 .08rem .2rem rgba(34, 34, 34, .16);
  color: #484848;
}

.kefu .van-icon {
  font-size: .5rem;
}

.kefu-hide {
  transform: translateX(.36rem);
}

/* Match the login and registration pages: identical service portrait,
 * location and retract animation. */


.kefu {
  right: 13px;
  bottom: 10vh;
  display: block;
  width: 50px;
  height: 50px;
  overflow: visible;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.kefu_img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

/* Account centre type scale: 12px helper text, 14px body text, 16px headings/amounts. */
.mine {
	min-height: calc(100vh - 56px);
	padding: 20px 16px 84px;
}

.profile-header {
	min-height: 68px;
	margin: 0;
}

.profile-avatar {
	width: 60px;
	height: 60px;
	margin-right: 10px;
}

.profile-name {
	max-width: 140px;
	font-size: 16px;
	line-height: 1.35;
}

.vip-badge,
.profile-detail,
.copy-code {
	font-size: 12px;
}

.vip-badge {
	padding: 2px 6px;
	line-height: 1.35;
}

.profile-detail {
	line-height: 1.45;
}

.copy-code {
	min-height: 24px;
	padding: 0 8px;
	border-radius: 5px;
	line-height: 1;
}

.notice-button {
	width: 40px;
	height: 40px;
	border: 1px solid rgba(235, 235, 235, .9);
	box-shadow: 0 5px 13px rgba(34, 34, 34, .1);
}

/deep/ .notice-button .van-icon {
	font-size: 22px !important;
}

.balance-card {
	margin-top: 16px;
	border: 1px solid rgba(255, 255, 255, .95);
	border-radius: 16px;
	background: rgba(255, 255, 255, .96);
	box-shadow: 0 9px 24px rgba(36, 45, 58, .08);
}

.balance-content {
	padding: 16px;
}

.balance-title,
.invite-label {
	font-size: 14px;
	line-height: 1.4;
}

.balance-title i {
	width: 4px;
	height: 16px;
	margin-right: 7px;
}

.balance-amount {
	margin-top: 8px;
	line-height: 1.2;
}

.balance-number {
	font-size: 16px;
	letter-spacing: 0;
}

.balance-unit,
.stat-label {
	font-size: 12px;
}

.balance-stats {
	margin-top: 14px;
	padding-top: 12px;
}

.balance-stat + .balance-stat {
	padding-left: 16px;
}

.stat-label {
	line-height: 1.4;
}

.stat-value {
	margin-top: 3px;
	font-size: 14px;
	line-height: 1.4;
}

.invite-row {
	min-height: 48px;
	padding: 0 16px;
}

.invite-label img {
	width: 22px;
	height: 22px;
	margin-right: 7px;
}

.quick-actions {
	gap: 10px;
	margin-top: 14px;
}

.quick-action {
	height: 48px;
	border-radius: 12px;
	font-size: 14px;
}

.quick-action img {
	width: 26px;
	height: 26px;
	margin-right: 7px;
}

.promotion-banner {
	margin-top: 16px;
	border-radius: 16px;
	box-shadow: 0 8px 20px rgba(38, 50, 67, .1);
}

.settings-list {
	margin-top: 16px;
	padding: 4px 12px;
	border: 1px solid rgba(255, 255, 255, .96);
	border-radius: 16px;
	background: rgba(255, 255, 255, .96);
	box-shadow: 0 8px 22px rgba(38, 50, 67, .07);
}

/deep/ .settings-list .van-cell {
	min-height: 56px;
	padding: 0 4px;
	align-items: center;
	font-size: 14px;
	line-height: 1.4;
}

/deep/ .settings-list .van-cell__title,
/deep/ .settings-list .van-cell__value {
	font-size: 14px;
	line-height: 1.4;
}

/deep/ .settings-list .van-cell__left-icon {
	min-width: 26px;
	margin-right: 8px;
	font-size: 20px;
	line-height: 1;
}

/deep/ .settings-list .van-cell__right-icon {
	font-size: 16px;
}

/deep/ .settings-list .van-cell:not(:last-child)::after {
	left: 38px;
}

.logout-button {
	height: 48px;
	margin-top: 16px;
	border-radius: 12px;
	font-size: 14px;
}

/* Warm, quiet account card with one clear coral activity accent. */
.user-wrap {
  background: linear-gradient(180deg, rgba(248, 247, 247, .18), rgba(250, 248, 247, .3)),
    url('../images/shop2/2.png') no-repeat center top / cover;
  color: #222;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.balance-card {
  border: 1px solid #eee7e4;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(45, 36, 34, .08);
}

.balance-content {
  padding: 20px 20px 17px;
}

.balance-title {
  color: #6a6665;
  font-weight: 600;
}

.balance-title i {
  width: 4px;
  height: 16px;
  margin-right: 9px;
  border-radius: 3px;
  background: #ff385c;
}

.balance-amount {
  margin-top: 12px;
  gap: 3px;
}

.balance-number {
  color: #222;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -.02em;
}

.balance-unit {
  color: #484848;
  font-size: 14px;
  font-weight: 600;
}

.balance-stats {
  margin-top: 18px;
  padding-top: 17px;
  border-top: 1px solid #f0ecea;
}

.balance-stat + .balance-stat {
  padding-left: 18px;
  border-left: 1px solid #f0ecea;
}

.stat-label {
  color: #77706e;
  font-size: 12px;
}

.stat-value {
  margin-top: 5px;
  color: #282524;
  font-size: 14px;
  font-weight: 700;
}

.invite-row {
  min-height: 64px;
  padding: 0 20px;
  border-top: 1px solid #f0ecea;
  background: #fff;
  color: #292524;
  transition: background-color .2s ease;
}

.invite-row:active {
  background: #fff7f6;
}

.invite-label {
  gap: 11px;
  font-size: 14px;
  font-weight: 600;
}

.invite-icon {
  display: inline-flex;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #fff0f1;
  color: #ff385c;
}

.invite-icon .van-icon {
  font-size: 20px;
}

.invite-arrow {
  color: #9a9290;
  font-size: 16px;
}

</style>
